<template lang="html">
  <b-modal
    :id="modalId"
    no-close-on-backdrop
    size="lg"
    @shown="init()"
    @hidden="hideModal"
  >
    <template v-slot:modal-header>
      <div>
        <h5 class="modal-title">{{ modalTitle }}</h5>
        <div>{{ modalSubtitle }}</div>
      </div>
    </template>
    <sublist-edit
      v-if="hasData"
      :appId="appId"
      :all-des="desClone"
      :de="dataElement"
      @on-de-name-changed="onDeNameChanged"
    />
    <template v-slot:modal-footer>
      <button
        class="modal-btn no-user-select modal-cancel-btn"
        @click="hideModal()"
      >
        {{ getMessageText(messages.CANCEL) }}
      </button>
      <button
        class="modal-btn no-user-select modal-save-btn"
        :disabled="isDisabled"
        @click="finishQuery()"
      >
        {{ getMessageText(messages.OK) }}
      </button>
    </template>
  </b-modal>
</template>

<script lang="js">
  import { mapState } from "vuex";
  import { MUTATION_NAME } from "@/static/global-variables";
  import utils from "@/utils";
  import store from "@/store";
  import validatorUtil from "@/utils/validator-util";
  import SublistEdit from "@/components/queries/sublist/SublistEdit";

  export default {
    name: "sublist-edit-modal",
    components: {
      SublistEdit
    },
    props: {
      appId: String,
      de: Object,
      id: String,
      name: String,
      allDes: Object
    },
    data() {
      return {
        dataElement: null,
        desClone: null,
        isNameValid: false
      };
    },
    computed: {
      ...mapState({
        messages: "messages",
        editDataElement: "editDataElement"
      }),
      modalId() {
        return "sublist-edit-modal_" + this.de.id;
      },
      isDisabled() {
        return !validatorUtil.isValidSublist(this.editDataElement) || !this.isNameValid;
      },
      hasData() {
        return Boolean(this.dataElement && this.desClone);
      },
      formattedSublistElement() {
        return validatorUtil.formatSublist(this.editDataElement);
      },
      modalTitle() {
        return `${this.getMessageText(this.messages.Edit)} ${this.$t(
          utils.getDataElementLabel(this.de.type)
        )}`;
      },
      modalSubtitle() {
        return utils.getModalSubtitle(this.de.type);
      }
    },
    methods: {
      hideModal() {
        if (this.de.notReady) {
          const params = {
            appId: this.de.appId,
            deId: this.de.id
          };
          store.commit(MUTATION_NAME.DELETE_DATA_ELEMENT, params);
        }
        this.dataElement = null;
        this.desClone = null;
        this.$bvModal.hide(this.modalId);
      },
      finishQuery() {
        let deInfo = {
          appId: this.appId,
          de: {
            id: this.dataElement.id,
            name: this.formattedSublistElement.name,
            description: this.formattedSublistElement.description,
            original: this.formattedSublistElement.original,
            originLabel: this.formattedSublistElement.originLabel,
            type: this.formattedSublistElement.type,
            skip: this.formattedSublistElement.skip,
            keep: this.formattedSublistElement.keep
          }
        };
        store.commit(MUTATION_NAME.UPDATE_DE_QUERY, deInfo);
        this.$bvModal.hide(this.modalId);
      },
      init() {
        this.dataElement = JSON.parse(JSON.stringify(this.de));
        this.desClone = JSON.parse(JSON.stringify(this.allDes));
      },
      onDeNameChanged(val) {
        this.isNameValid = val;
      }
    }
  };
</script>

<style scoped lang="scss">
  .modal-btn {
    position: relative;
    display: inline-flex;
    align-items: center;
    padding: 0;
    background: transparent;
    background-clip: border-box;
    border: 1px solid transparent;
    border-radius: 0.25rem;
    line-height: 1.875rem;
    color: #0070d2;
    -webkit-appearance: none;
    white-space: normal;
    text-decoration: none;
  }

  .modal-btn[disabled] {
    background-color: var(--DISABLED_BTN_GREY);
    border-color: var(--DISABLED_BTN_GREY);
    color: var(--WHITE);
  }

  .modal-save-btn {
    margin-left: 0.5rem;
    padding-left: 1rem;
    padding-right: 1rem;
    text-align: center;
    vertical-align: middle;
    justify-content: center;
    transition: border 0.15s linear;
    background-color: #0070d2;
    border: 1px solid #0070d2;
    color: #fff;
  }
</style>
